/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Sync API
 * An API for notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationResponse
 */
export interface NotificationResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationResponse
     */
    bookings: Array<string>;
}

export function NotificationResponseFromJSON(json: any): NotificationResponse {
    return NotificationResponseFromJSONTyped(json, false);
}

export function NotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bookings': json['bookings'],
    };
}

export function NotificationResponseToJSON(value?: NotificationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bookings': value.bookings,
    };
}


